import { render, staticRenderFns } from "./OrganizationClientForm.vue?vue&type=template&id=33805e20"
import script from "./OrganizationClientForm.vue?vue&type=script&lang=js"
export * from "./OrganizationClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports